import { render, staticRenderFns } from "./FacilityDetails.vue?vue&type=template&id=506891a0&scoped=true&"
import script from "./FacilityDetails.vue?vue&type=script&lang=js&"
export * from "./FacilityDetails.vue?vue&type=script&lang=js&"
import style0 from "./FacilityDetails.vue?vue&type=style&index=0&id=506891a0&scoped=true&lang=css&"
import style1 from "./FacilityDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506891a0",
  null
  
)

export default component.exports